import { Building2, Cog, Puzzle, Users } from "lucide-vue-next";

export interface SettingsPage {
  key: string;
  label: string;
  icon: typeof Cog;
}

export const SETTINGS_PAGES: SettingsPage[] = [
  {
    key: "general",
    label: "settings.general",
    icon: Cog,
  },
  {
    key: "organizations",
    label: "settings.organizations",
    icon: Building2,
  },
  {
    key: "members",
    label: "settings.organizationMembers",
    icon: Users,
  },
  {
    key: "mcpServers",
    label: "settings.mcpServers.title",
    icon: Puzzle,
  },
];
